import React from "react";

import {
  TextField,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
} from "@mui/material";

import { BlockStandard } from "components/admin/BlockStandard";
import { DetailedSelector } from "components/admin/DetailedSelector";
import { PhotoUploadGrid } from "components/forms/PhotoUploadGrid";

// Options from the image
const COVERAGE_OPTIONS = [
  "Cobertura de telha cerâmica",
  "Cobertura de fibrocimento",
  "Cobertura metálica",
  "Laje",
  "Solo",
];

const ORIENTATION_OPTIONS = ["Norte", "Sul", "Oeste", "Leste"];

const CONDITION_OPTIONS = ["Boa", "Ruim"];

export const InstallationFieldDetail = ({
  installationData,
  onChange,
}: InstallationFieldDetailProps) => {
  const handleCoverageChange = ({ target: { value } }) => {
    onChange({
      ...installationData,
      coverage_area_installed: value,
    });
  };

  const handleOrientationChange = ({ target: { value } }) => {
    onChange({
      ...installationData,
      coverage_guidance: value,
    });
  };

  const handleSlopeChange = ({ target: { value } }) => {
    onChange({
      ...installationData,
      slope_installation_side: value,
    });
  };

  const handleConditionChange = ({ target: { value } }) => {
    onChange({
      ...installationData,
      installation_local_condition: value,
    });
  };

  const handlePhotosChange = (photos: File[]) => {
    onChange({
      ...installationData,
      location_pictures: photos,
    });
  };

  const handleAreaChange = ({ target: { value } }) => {
    onChange({
      ...installationData,
      area_available_installation: value,
    });
  };

  return (
    <BlockStandard>
      <Typography variant="subtitle1">Local da instalação</Typography>

      <DetailedSelector hideEnvironment />

      <Grid item container direction="column" gap={2}>
        <FormControl fullWidth>
          <InputLabel>Cobertura do local da instalação</InputLabel>
          <Select
            value={installationData.coverage_area_installed}
            onChange={handleCoverageChange}
            label="Cobertura do local da instalação"
          >
            {COVERAGE_OPTIONS.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl fullWidth>
          <InputLabel>Orientação da cobertura</InputLabel>
          <Select
            value={installationData.coverage_guidance}
            onChange={handleOrientationChange}
            label="Orientação da cobertura"
          >
            {ORIENTATION_OPTIONS.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <TextField
          fullWidth
          label="Inclinação do local de instalação"
          placeholder="Informe o ângulo de inclinação do painel"
          value={installationData.slope_installation_side}
          onChange={handleSlopeChange}
        />

        <FormControl fullWidth>
          <InputLabel>Condições do local de instalação</InputLabel>
          <Select
            value={installationData.installation_local_condition}
            onChange={handleConditionChange}
            label="Condições do local de instalação"
          >
            {CONDITION_OPTIONS.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <PhotoUploadGrid
          photos={installationData.location_pictures}
          onPhotosChange={handlePhotosChange}
          buttonText="Enviar foto"
        />

        <TextField
          fullWidth
          label="Área disponível para instalação"
          placeholder="Descreva"
          value={installationData.area_available_installation}
          onChange={handleAreaChange}
        />
      </Grid>
    </BlockStandard>
  );
};

export type InstallationFieldDetailProps = {
  installationData: InstallationFieldDetailItem;
  onChange: (updated: InstallationFieldDetailItem) => void;
};

export type InstallationFieldDetailItem = {
  coverage_area_installed: string;
  coverage_guidance: string;
  slope_installation_side: string;
  installation_local_condition: string;
  location_pictures: File[];
  area_available_installation: string;
};

export const emptyInstallationField: InstallationFieldDetailItem = {
  coverage_area_installed: "",
  coverage_guidance: "",
  slope_installation_side: "",
  installation_local_condition: "",
  location_pictures: [],
  area_available_installation: "",
};
